import type {} from '@angular/localize/init';
import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { appRoutesI18nCache } from '../i18n-cache';

export function bpBetBuilderRouteI18n(config?: TranslationConfig): string {
  if (config?.translateForLang && globalThis.$localizeForLang) {
    return globalThis.$localizeForLang`:url-segment@@bp-bet-builder-url-segment:bet-builder`;
  }
  return (appRoutesI18nCache['bp-bet-builder'] ??= $localize`:url-segment@@bp-bet-builder-url-segment:bet-builder`);
}
